import ReactApexChart from "react-apexcharts";
import React from 'react';
import './Performance.css'

class PerformanceChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            series: [{
                name: 'Cash Flow',
                data: [0.11, 0, 0, 0, 0, 0, 0, 0, 0,0, 0, 0]
            }],
            options: {
                chart: {
                    type: 'bar',
                    height: 350
                },
                plotOptions: {
                    bar: {
                        colors: {
                            ranges: [{
                                from: -100,
                                to: -46,
                                color: '#F15B46'
                            }, {
                                from: -45,
                                to: 0,
                                color: '#FEB019'
                            }]
                        },
                        columnWidth: '40%',
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                yaxis: {
                    title: {
                        text: '',
                    },
                    labels: {
                        formatter: function (y) {
                            return y.toFixed(0) + "%";
                        }
                    }
                },
                xaxis: {

                    categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                    labels: {
                        rotate: -90
                    }
                }
            }
        };
    }




    componentDidUpdate(prevProps) {
        
        if (this.props.rowSelected && prevProps.rowSelected !== this.props.rowSelected) {
            this.setState({
                ...this.state.series,
                series: [
                    {
                        data: this.props.rowSelected
                    }
                ]
            });
        }
    }
    render() {
        return (
            <div id="PerformanceChart">
                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={200} />
            </div>

        );
    }
}

export default PerformanceChart;